<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template functional>
    <footer class="the-footer flex-wrap justify-between" :class="classes">
        <span><b>Support</b><br>Email: esd@techprodc.com<br>Phone: +99412 488 10 01 (ext:1131)</span>
        <span class="items-center"><br>
            <a href="https://techprodc.com/about" target="_blank" rel="nofollow" style="display: inline-block;height: 33px;overflow: hidden;">
                <img src="@/assets/images/logo/made_with_new.svg" height="60" style="margin-left: -19px;margin-top: -13px;">
            </a>
        </span>
        <span><br>COPYRIGHT @ {{ new Date().getFullYear() }}, All rights Reserved</span>
    </footer>
</template>

<script>

export default {
    name: "the-footer",
    props: {
        classes: {
            type: String,
        },
    }
}
</script>
